// import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./home.css";
import Img1 from "./img1.png";
import Img2 from "./img2.png";
import Img3 from "./img3.png";
import Img4 from "./img4.png";
import Img5 from "./img5.png";
import Img6 from "./img6.png";
import Img7 from "./img7.png";
import Img11 from "./img10.png";
// import Img8 from "./img8.png";
import Img8 from "../recipes/img4.png";
import Img9 from "../recipes/img3.png";
import Img10 from "../recipes/img7.png";
// import Img9 from "./img9.png";
import ControlledCarousel from "./ControlledCarousel";
import EcavowhiteComponent from "../../components/ecavowhiteComponent/EcavowhiteComponent";
import EcavoblackComponent from "../../components/ecavoblackComponent/EcavoblackComponent";
// import Whatsapp from "../../components/whatsapp/Whatsapp";
import Recipie from "../../components/recipie/Recipie";
// import Bots from "../../components/chatbot/Bots";
import { Link } from "react-router-dom";
import React, { useEffect } from "react";
const Home = () => {

  return (
    <>
      <Navb />
      {/* <Whatsapp /> */}
      <ControlledCarousel />
      <div className="ecavoByNandiAgro bg0">
        <div className="whiteHeading">Introduction of Nandi</div>
        <p className="whiteP ecavoByNandiAgroP">
          Nandi is an Indian grocery brand, we serve a wide range of products
          like{" "}
          <b>
            {" "}
            Chakki Atta, Maida, Sooji, Dalia, Besan, Pink Rock Salt, Pickles,
            Range of Spices and more.
          </b>{" "}
          We strive to be your partners in preserving and warding your family’s
          health. To ensure the best quality and taste we procure all the raw
          materials directly from their respective excelling regions that are
          known for highest quality standards and accepted globally. Food cooked
          using Nandi products fulfill your nutritional needs for a balanced
          diet 24*7!
        </p>
        <p className="whiteP">"Let food be thy medicine"</p>
        {/* <Link to="/m" className="whiteButton">
          Know More
        </Link> */}
      </div>
      <div className="nandiSpices bg1">
        <div className="BlackHeading headingNandiSpices">Nandi Spices</div>
        <p className="blackP nandiSpicesP">
          Unleash the flavor revolution with Nandi Spices - where each blend
          tells a tale of exotic lands and aromatic journeys. From the fiery
          embrace of cayenne to the soothing whispers of cinnamon, our spices
          dance on your palate, creating symphonies of taste. Elevate your
          culinary adventures with Nandi, where every dish becomes a masterpiece
          in the making.
        </p>
        <img src={Img1} alt="nandiSpices" />
        <Link to="/spices" className="blackButton">
          Know More
        </Link>
      </div>
      <div className="whiteComponentEcavo bg2">
        <EcavowhiteComponent
          currrentImg={Img2}
          heading="Nandi CHAKKI AATA"
          text="Whole wheat Atta undergoes stone grinding, a method that imparts a
            distinct aroma and flavor to Rotis. Its authentic whole-grain
            composition, with a high bran content, makes it a fiber-rich food.
            This contributes to the regulation of digestion, blood sugar,
            cholesterol, obesity, and enhances skin quality, offering various
            health benefits. The temperatures reached during the chakki (stone
            mill or grinder) process, generated through friction, typically
            range from 110-125°C. At these elevated temperatures, the carotenes
            in the bran release a distinctive roasty fragrance, lending the atta
            its golden color."
          Link="/aata"
        />
      </div>
      <div className="whiteComponentEcavo bg3">
        <EcavoblackComponent
          currrentImg={Img3}
          heading="NANDI Besan"
          text="Unleash the flavor revolution with Ecavo Spices - where each blend tells a tale of exotic lands and aromatic journeys. From the fiery embrace of cayenne to the soothing whispers of cinnamon, our spices dance on your palate, creating symphonies of taste. Elevate your culinary adventures with Ecavo, where every dish becomes a masterpiece in the making."
          Link="/besan"
        />
      </div>
      <div className="whiteComponentEcavo bg4">
        <EcavowhiteComponent
          currrentImg={Img4}
          heading="NANDI Sooji"
          text="Crafted from the finest quality whole wheat, our Sooji stands out as a premium offering to our customers. Rich in carbohydrates and protein, this Sooji is perfect for preparing delicious meals like Upma or Halwa. Elevate your culinary experience and treat yourself, as well as your loved ones, to delectable and appetizing food using our Premium Quality Sooji. Its crispy texture and subtle aroma contribute to delivering an enticing flavor to your dishes."
          Link="/sooji"
        />
      </div>
      <div className="whiteComponentEcavo bg5">
        <EcavoblackComponent
          currrentImg={Img5}
          heading="NANDI Maida"
          text="As a distinguished entity in the agro industry, we are committed to delivering a top-notch selection of Premium Maida. We meticulously process and pack the freshest and finest wheat with stringent standards to ensure prolonged freshness. Our essential maida is the key ingredient for preparing a variety of delectable dishes, spanning from breakfast delights to snack items. We extend an invitation for you to indulge in the unparalleled joy of premium maida, enabling you to create a feast for your friends and family using finely ground wheat grains from reliable sources."
          Link="/maida"
        />
      </div>
      <div className="whiteComponentEcavo bg6">
        <EcavowhiteComponent
          currrentImg={Img6}
          heading="NANDI Himalayan Pink Rock Salt"
          text="Experience the essence of culinary finesse with Himalayan salt . Elevate your cooking to new heights with the purity of Himalayan salt, harmonizing perfectly with the delicate texture of refined flour. Indulge in the art of gastronomy, where every dish becomes a masterpiece infused with the finest ingredients from nature's bounty."
          Link="/salt"
        />
      </div>
      <div className="whiteComponentEcavo bg7">
        <EcavoblackComponent
          currrentImg={Img7}
          heading="NANDI Dalia"
          text="Introducing Ecavo Daliya - the epitome of culinary excellence! Delight your senses with this premium blend, meticulously crafted to elevate your dishes to new heights. Experience the perfect fusion of tradition and innovation in every spoonful, as the rich aroma and superior texture of Ecavo flour daliya transform your cooking into a masterpiece. Elevate your culinary creations today with Ecavo - where quality meets perfection!"
          Link="/dalia"
        />
      </div>
      <div className="whiteComponentEcavo bg8">
        <img src={Img11} alt="img2" />
        <div className="blackComponentEcavoText width40">
          <div className="blackHeading">NANDI Pickles</div>
          <p className="blackP">
            Indulge in the tantalizing flavors of Ecavo's Nandi’s Pickles, a
            fusion of delicate petals and tangy spices, handcrafted to
            perfection. Each jar is a symphony of notes and zesty undertones,
            promising a culinary adventure with every bite. Elevate your meals
            with the exquisite taste of Ecavo's pickles, adding a touch of
            elegance and sophistication to your dining experience.
          </p>
          {/* <button className="blackButton">Know More</button> */}
          <Link to="/pickles" className="blackButton">
            Know More
          </Link>
        </div>
        {/* <EcavoblackComponent
          Style="width40"
          currrentImg={Img11}
          heading="Pickles"
          text="Indulge in the tantalizing flavors of Ecavo's Nandi’s  Pickles, a fusion of delicate petals and tangy spices, handcrafted to perfection. Each jar is a symphony of notes and zesty undertones, promising a culinary adventure with every bite. Elevate your meals with the exquisite taste of Ecavo's pickles, adding a touch of elegance and sophistication to your dining experience."
          Link="/pickles"
        /> */}
      </div>
      {/* <AOSWrapper> */}
        <div className="homeRecipies bg9">
          {[Img8, Img10, Img9].map((img, index) => (
            <div
              key={index}
              
            >
              <Recipie
                IMG={img}
                RecipieName={
                  index === 0
                    ? "Maida Pizza Cone"
                    : index === 1
                    ? "Besan burfi"
                    : "Whole Atta Cookies"
                }
                RecipieLink={
                  index === 0
                    ? "maidavegpizzacones"
                    : index === 1
                    ? "besanburfi"
                    : "wholeattacookies"
                }
              />
            </div>
          ))}
        </div>
      {/* </AOSWrapper> */}
      {/* <div className="homeRecipies bg9">
        <Recipie
          IMG={Img8}
          RecipieName="Maida Pizza Cone"
          RecipieLink="maidavegpizzacones"
        />
        <Recipie
          IMG={Img10}
          RecipieName="Besan burfi "
          RecipieLink="besanburfi"
        />
        <Recipie
          IMG={Img9}
          RecipieName="Whole Atta Cookies"
          RecipieLink="wholeattacookies"
        />
      </div> */}
      {/* <Bots /> */}
      <Footer />
      {/* </AOSWrapper> */}
    </>
  );
};

export default Home;









// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import Navb from "../../components/navbar/Navb";
// import Footer from "../../components/footer/Footer";
// import "./home.css";
// import Img1 from "./img1.png";
// import Img2 from "./img2.png";
// import Img3 from "./img3.png";
// import Img4 from "./img4.png";
// import Img5 from "./img5.png";
// import Img6 from "./img6.png";
// import Img7 from "./img7.png";
// import Img11 from "./img10.png";
// import Img8 from "../recipes/img4.png";
// import Img9 from "../recipes/img3.png";
// import Img10 from "../recipes/img7.png";
// import ControlledCarousel from "./ControlledCarousel";
// import EcavowhiteComponent from "../../components/ecavowhiteComponent/EcavowhiteComponent";
// import EcavoblackComponent from "../../components/ecavoblackComponent/EcavoblackComponent";
// import Recipie from "../../components/recipie/Recipie";
// import { Link } from "react-router-dom";

// const getStaggeredDelay = (delayValues, index) => {
//   return delayValues[index % delayValues.length];
// };
// const Home = () => {
//   useEffect(() => {
//     console.log("Initializing AOS...");
//     AOS.init({
//       duration: 1000,
//       offset: 400,
//       once: true,
//       anchorPlacement: "top-bottom",
//       startEvent: "DOMContentLoaded",
//     });
//     AOS.refresh();
//     console.log("AOS initialized and refreshed.");
//   }, []);
  

//   return (
//     <>
//       <Navb />
//       <ControlledCarousel />
      
//       <div  className="ecavoByNandiAgro bg0">
//         <div data-aos="fade-up" data-aos-delay="100" className="whiteHeading">Introduction of Nandi</div>
//         <p data-aos="fade-up" data-aos-delay="200" className="whiteP ecavoByNandiAgroP">
//           Nandi is an Indian grocery brand, we serve a wide range of products like{" "}
//           <b>Chakki Atta, Maida, Sooji, Dalia, Besan, Pink Rock Salt, Pickles, Range of Spices and more.</b>{" "}
//           We strive to be your partners in preserving and warding your family's health. To ensure the best quality and taste we procure all the raw materials directly from their respective excelling regions that are known for highest quality standards and accepted globally. Food cooked using Nandi products fulfill your nutritional needs for a balanced diet 24*7!
//         </p>
//         <p data-aos="fade-up" data-aos-delay="300" className="whiteP">"Let food be thy medicine"</p>
//       </div>

//       <div  className="nandiSpices bg1">
//         <div data-aos="fade-up" data-aos-delay="300" className="BlackHeading headingNandiSpices">Nandi Spices</div>
//         <p data-aos="fade-up" data-aos-delay="300" className="blackP nandiSpicesP">
//           Unleash the flavor revolution with Nandi Spices - where each blend tells a tale of exotic lands and aromatic journeys. From the fiery embrace of cayenne to the soothing whispers of cinnamon, our spices dance on your palate, creating symphonies of taste. Elevate your culinary adventures with Nandi, where every dish becomes a masterpiece in the making.
//         </p>
//         <img data-aos="fade-up" data-aos-delay="400" src={Img1} alt="nandiSpices" />
//         <Link data-aos="fade-up" data-aos-delay="400" to="/spices" className="blackButton">
//           Know More
//         </Link>
//       </div>

//       <div data-aos="fade-up" data-aos-delay="500" className="whiteComponentEcavo bg2">
//         <EcavowhiteComponent
//           currrentImg={Img2}
//           heading="Nandi CHAKKI AATA"
//           text="Whole wheat Atta undergoes stone grinding, a method that imparts a distinct aroma and flavor to Rotis. Its authentic whole-grain composition, with a high bran content, makes it a fiber-rich food. This contributes to the regulation of digestion, blood sugar, cholesterol, obesity, and enhances skin quality, offering various health benefits. The temperatures reached during the chakki (stone mill or grinder) process, generated through friction, typically range from 110-125°C. At these elevated temperatures, the carotenes in the bran release a distinctive roasty fragrance, lending the atta its golden color."
//           Link="/aata"
//         />
//       </div>

//       <div data-aos="fade-up" data-aos-delay="600"  className="whiteComponentEcavo bg3">
//         <EcavoblackComponent
//           currrentImg={Img3}
//           heading="NANDI Besan"
//           text="Unleash the flavor revolution with Ecavo Spices - where each blend tells a tale of exotic lands and aromatic journeys. From the fiery embrace of cayenne to the soothing whispers of cinnamon, our spices dance on your palate, creating symphonies of taste. Elevate your culinary adventures with Ecavo, where every dish becomes a masterpiece in the making."
//           Link="/besan"
//         />
//       </div>

//       <div data-aos="fade-up" data-aos-delay="700" className="whiteComponentEcavo bg4">
//         <EcavowhiteComponent
//           currrentImg={Img4}
//           heading="NANDI Sooji"
//           text="Crafted from the finest quality whole wheat, our Sooji stands out as a premium offering to our customers. Rich in carbohydrates and protein, this Sooji is perfect for preparing delicious meals like Upma or Halwa. Elevate your culinary experience and treat yourself, as well as your loved ones, to delectable and appetizing food using our Premium Quality Sooji. Its crispy texture and subtle aroma contribute to delivering an enticing flavor to your dishes."
//           Link="/sooji"
//         />
//       </div>

//       <div data-aos="fade-up" data-aos-delay="800" className="whiteComponentEcavo bg5">
//         <EcavoblackComponent
//           currrentImg={Img5}
//           heading="NANDI Maida"
//           text="As a distinguished entity in the agro industry, we are committed to delivering a top-notch selection of Premium Maida. We meticulously process and pack the freshest and finest wheat with stringent standards to ensure prolonged freshness. Our essential maida is the key ingredient for preparing a variety of delectable dishes, spanning from breakfast delights to snack items. We extend an invitation for you to indulge in the unparalleled joy of premium maida, enabling you to create a feast for your friends and family using finely ground wheat grains from reliable sources."
//           Link="/maida"
//         />
//       </div>

//       <div data-aos="fade-up" data-aos-delay="900" className="whiteComponentEcavo bg6">
//         <EcavowhiteComponent
//           currrentImg={Img6}
//           heading="NANDI Himalayan Pink Rock Salt"
//           text="Experience the essence of culinary finesse with Himalayan salt . Elevate your cooking to new heights with the purity of Himalayan salt, harmonizing perfectly with the delicate texture of refined flour. Indulge in the art of gastronomy, where every dish becomes a masterpiece infused with the finest ingredients from nature's bounty."
//           Link="/salt"
//         />
//       </div>

//       <div data-aos="fade-up" data-aos-delay="1000" className="whiteComponentEcavo bg7">
//         <EcavoblackComponent
//           currrentImg={Img7}
//           heading="NANDI Dalia"
//           text="Introducing Ecavo Daliya - the epitome of culinary excellence! Delight your senses with this premium blend, meticulously crafted to elevate your dishes to new heights. Experience the perfect fusion of tradition and innovation in every spoonful, as the rich aroma and superior texture of Ecavo flour daliya transform your cooking into a masterpiece. Elevate your culinary creations today with Ecavo - where quality meets perfection!"
//           Link="/dalia"
//         />
//       </div>

//       <div data-aos="fade-up" className="whiteComponentEcavo bg8">
//         <img src={Img11} alt="img2" />
//         <div className="blackComponentEcavoText width40">
//           <div className="blackHeading">NANDI Pickles</div>
//           <p className="blackP">
//             Indulge in the tantalizing flavors of Ecavo's Nandi's Pickles, a fusion of delicate petals and tangy spices, handcrafted to perfection. Each jar is a symphony of notes and zesty undertones, promising a culinary adventure with every bite. Elevate your meals with the exquisite taste of Ecavo's pickles, adding a touch of elegance and sophistication to your dining experience.
//           </p>
//           <Link to="/pickles" className="blackButton">
//             Know More
//           </Link>
//         </div>
//       </div>

//       <div className="homeRecipies bg9">
//         {[Img8, Img10, Img9].map((img, index) => (
//           <div
//             key={index}
//             data-aos="fade-up"
//             data-aos-duration="1000"
//             data-aos-delay={getStaggeredDelay([0, 200, 400], index)}
//             data-aos-anchor-placement="bottom-bottom"
//           >
//             <Recipie
//               IMG={img}
//               RecipieName={
//                 index === 0
//                   ? "Maida Pizza Cone"
//                   : index === 1
//                   ? "Besan burfi"
//                   : "Whole Atta Cookies"
//               }
//               RecipieLink={
//                 index === 0
//                   ? "maidavegpizzacones"
//                   : index === 1
//                   ? "besanburfi"
//                   : "wholeattacookies"
//               }
//             />
//           </div>
//         ))}
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default Home;
// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import Navb from "../../components/navbar/Navb";
// import Footer from "../../components/footer/Footer";
// import "./home.css";
// import Img1 from "./img1.png";
// import Img2 from "./img2.png";
// import Img3 from "./img3.png";
// import Img4 from "./img4.png";
// import Img5 from "./img5.png";
// import Img6 from "./img6.png";
// import Img7 from "./img7.png";
// import Img11 from "./img10.png";
// import Img8 from "../recipes/img4.png";
// import Img9 from "../recipes/img3.png";
// import Img10 from "../recipes/img7.png";
// import ControlledCarousel from "./ControlledCarousel";
// import EcavowhiteComponent from "../../components/ecavowhiteComponent/EcavowhiteComponent";
// import EcavoblackComponent from "../../components/ecavoblackComponent/EcavoblackComponent";
// import Recipie from "../../components/recipie/Recipie";
// import { Link } from "react-router-dom";
// import useAOS from '../../components/hooks/useAOS';

// const getStaggeredDelay = (delayValues, index) => {
//   return delayValues[index % delayValues.length];
// };

// const Home = () => {
//   // useEffect(() => {
//   //   AOS.init({
//   //     duration: 1000,
//   //     offset: 400,
//   //     once: true,
//   //     anchorPlacement: "top-bottom",
//   //   });
//   //   AOS.refresh();
//   // }, []);
//   useAOS();
//   return (
//     <>
//       <Navb />
//       <ControlledCarousel />

//       <div className="ecavoByNandiAgro bg0">
//         <div data-aos="fade-up" data-aos-delay="100" className="whiteHeading">Introduction of Nandi</div>
//         <p data-aos="fade-up" data-aos-delay="200" className="whiteP ecavoByNandiAgroP">
//           Nandi is an Indian grocery brand, we serve a wide range of products like{" "}
//           <b>Chakki Atta, Maida, Sooji, Dalia, Besan, Pink Rock Salt, Pickles, Range of Spices and more.</b>{" "}
//           We strive to be your partners in preserving and warding your family's health. To ensure the best quality and taste we procure all the raw materials directly from their respective excelling regions that are known for highest quality standards and accepted globally. Food cooked using Nandi products fulfill your nutritional needs for a balanced diet 24*7!
//         </p>
//         <p data-aos="fade-up" data-aos-delay="300" className="whiteP">"Let food be thy medicine"</p>
//       </div>

//       <div className="nandiSpices bg1">
//         <div data-aos="fade-up" data-aos-delay="400" className="BlackHeading headingNandiSpices">Nandi Spices</div>
//         <p data-aos="fade-up" data-aos-delay="500" className="blackP nandiSpicesP">
//           Unleash the flavor revolution with Nandi Spices - where each blend tells a tale of exotic lands and aromatic journeys. From the fiery embrace of cayenne to the soothing whispers of cinnamon, our spices dance on your palate, creating symphonies of taste. Elevate your culinary adventures with Nandi, where every dish becomes a masterpiece in the making.
//         </p>
//         <img data-aos="fade-up" data-aos-delay="600" src={Img1} alt="nandiSpices" />
//         <Link data-aos="fade-up" data-aos-delay="700" to="/spices" className="blackButton">
//           Know More
//         </Link>
//       </div>

//       <div  className="whiteComponentEcavo bg2">
//         <EcavowhiteComponent
//           currrentImg={Img2}
//           heading="Nandi CHAKKI AATA"
//           text="Whole wheat Atta undergoes stone grinding, a method that imparts a distinct aroma and flavor to Rotis. Its authentic whole-grain composition, with a high bran content, makes it a fiber-rich food. This contributes to the regulation of digestion, blood sugar, cholesterol, obesity, and enhances skin quality, offering various health benefits. The temperatures reached during the chakki (stone mill or grinder) process, generated through friction, typically range from 110-125°C. At these elevated temperatures, the carotenes in the bran release a distinctive roasty fragrance, lending the atta its golden color."
//           Link="/aata"
//         />
//       </div>

//       <div className="whiteComponentEcavo bg3">
//         <EcavoblackComponent
//           currrentImg={Img3}
//           heading="NANDI Besan"
//           text="Unleash the flavor revolution with Ecavo Spices - where each blend tells a tale of exotic lands and aromatic journeys. From the fiery embrace of cayenne to the soothing whispers of cinnamon, our spices dance on your palate, creating symphonies of taste. Elevate your culinary adventures with Ecavo, where every dish becomes a masterpiece in the making."
//           Link="/besan"
//         />
//       </div>

//       <div className="whiteComponentEcavo bg4">
//         <EcavowhiteComponent
//           currrentImg={Img4}
//           heading="NANDI Sooji"
//           text="Crafted from the finest quality whole wheat, our Sooji stands out as a premium offering to our customers. Rich in carbohydrates and protein, this Sooji is perfect for preparing delicious meals like Upma or Halwa. Elevate your culinary experience and treat yourself, as well as your loved ones, to delectable and appetizing food using our Premium Quality Sooji. Its crispy texture and subtle aroma contribute to delivering an enticing flavor to your dishes."
//           Link="/sooji"
//         />
//       </div>

//       <div className="whiteComponentEcavo bg5">
//         <EcavoblackComponent
//           currrentImg={Img5}
//           heading="NANDI Maida"
//           text="As a distinguished entity in the agro industry, we are committed to delivering a top-notch selection of Premium Maida. We meticulously process and pack the freshest and finest wheat with stringent standards to ensure prolonged freshness. Our essential maida is the key ingredient for preparing a variety of delectable dishes, spanning from breakfast delights to snack items. We extend an invitation for you to indulge in the unparalleled joy of premium maida, enabling you to create a feast for your friends and family using finely ground wheat grains from reliable sources."
//           Link="/maida"
//         />
//       </div>

//       <div className="whiteComponentEcavo bg6">
//         <EcavowhiteComponent
//           currrentImg={Img6}
//           heading="NANDI Himalayan Pink Rock Salt"
//           text="Experience the essence of culinary finesse with Himalayan salt. Elevate your cooking to new heights with the purity of Himalayan salt, harmonizing perfectly with the delicate texture of refined flour. Indulge in the art of gastronomy, where every dish becomes a masterpiece infused with the finest ingredients from nature's bounty."
//           Link="/salt"
//         />
//       </div>

//       <div className="whiteComponentEcavo bg7">
//         <EcavoblackComponent
//           currrentImg={Img7}
//           heading="NANDI Dalia"
//           text="Introducing Ecavo Daliya - the epitome of culinary excellence! Delight your senses with this premium blend, meticulously crafted to elevate your dishes to new heights. Experience the perfect fusion of tradition and innovation in every spoonful, as the rich aroma and superior texture of Ecavo flour daliya transform your cooking into a masterpiece. Elevate your culinary creations today with Ecavo - where quality meets perfection!"
//           Link="/dalia"
//         />
//       </div>

//       <div className="whiteComponentEcavo bg8">
//         <img src={Img11} alt="img2" />
//         <div className="blackComponentEcavoText width40">
//           <div className="blackHeading">NANDI Pickles</div>
//           <p className="blackP">
//             Indulge in the tantalizing flavors of Ecavo's Nandi's Pickles, a fusion of delicate petals and tangy spices, handcrafted to perfection. Each jar is a symphony of notes and zesty undertones, promising a culinary adventure with every bite. Elevate your meals with the exquisite taste of Ecavo's pickles, adding a touch of elegance and sophistication to your dining experience.
//           </p>
//           <Link to="/pickles" className="blackButton">
//             Know More
//           </Link>
//         </div>
//       </div>

//       <div className="homeRecipies bg9">
//         {[Img8, Img10, Img9].map((img, index) => (
//           <div
//             key={index}
//             data-aos="fade-up"
//             data-aos-duration="1000"
//             data-aos-delay={getStaggeredDelay([0, 200, 400], index)}
//             data-aos-anchor-placement="bottom-bottom"
//           >
//             <Recipie
//               IMG={img}
//               RecipieName={
//                 index === 0
//                   ? "Maida Pizza Cone"
//                   : index === 1
//                   ? "Besan burfi"
//                   : "Whole Atta Cookies"
//               }
//               RecipieLink={
//                 index === 0
//                   ? "maidavegpizzacones"
//                   : index === 1
//                   ? "besanburfi"
//                   : "wholeattacookies"
//               }
//             />
//           </div>
//         ))}
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default Home;
// import React from "react";
// import Navb from "../../components/navbar/Navb";
// import Footer from "../../components/footer/Footer";
// import "./home.css";
// import Img1 from "./img1.png";
// import Img2 from "./img2.png";
// import Img3 from "./img3.png";
// import Img4 from "./img4.png";
// import Img5 from "./img5.png";
// import Img6 from "./img6.png";
// import Img7 from "./img7.png";
// import Img11 from "./img10.png";
// import Img8 from "../recipes/img4.png";
// import Img9 from "../recipes/img3.png";
// import Img10 from "../recipes/img7.png";
// import ControlledCarousel from "./ControlledCarousel";
// import EcavowhiteComponent from "../../components/ecavowhiteComponent/EcavowhiteComponent";
// import EcavoblackComponent from "../../components/ecavoblackComponent/EcavoblackComponent";
// import Recipie from "../../components/recipie/Recipie";
// import { Link } from "react-router-dom";
// import useIntersectionObserver from '../../components/hooks/useIntersectionObserver';

// const Home = () => {
//   const [introRef, introInView] = useIntersectionObserver({ threshold: 0.1 });
//   const [spicesRef, spicesInView] = useIntersectionObserver({ threshold: 0.1 });
//   const [recipesRef, recipesInView] = useIntersectionObserver({ threshold: 0.1 });

//   return (
//     <>
//       <Navb />
//       <ControlledCarousel />

//       <div ref={introRef} className={`ecavoByNandiAgro bg0 ${introInView ? 'animate' : ''}`}>
//         <div className="whiteHeading">Introduction of Nandi</div>
//         <p className="whiteP ecavoByNandiAgroP">
//           Nandi is an Indian grocery brand, we serve a wide range of products like{" "}
//           <b>Chakki Atta, Maida, Sooji, Dalia, Besan, Pink Rock Salt, Pickles, Range of Spices and more.</b>{" "}
//           We strive to be your partners in preserving and warding your family's health. To ensure the best quality and taste we procure all the raw materials directly from their respective excelling regions that are known for highest quality standards and accepted globally. Food cooked using Nandi products fulfill your nutritional needs for a balanced diet 24*7!
//         </p>
//         <p className="whiteP">"Let food be thy medicine"</p>
//       </div>

//       <div ref={spicesRef} className={`nandiSpices bg1 ${spicesInView ? 'animate' : ''}`}>
//         <div className="BlackHeading headingNandiSpices">Nandi Spices</div>
//         <p className="blackP nandiSpicesP">
//           Unleash the flavor revolution with Nandi Spices - where each blend tells a tale of exotic lands and aromatic journeys. From the fiery embrace of cayenne to the soothing whispers of cinnamon, our spices dance on your palate, creating symphonies of taste. Elevate your culinary adventures with Nandi, where every dish becomes a masterpiece in the making.
//         </p>
//         <img src={Img1} alt="nandiSpices" />
//         <Link to="/spices" className="blackButton">
//           Know More
//         </Link>
//       </div>

//       <div className="whiteComponentEcavo bg2">
//         <EcavowhiteComponent
//           currrentImg={Img2}
//           heading="Nandi CHAKKI AATA"
//           text="Whole wheat Atta undergoes stone grinding, a method that imparts a distinct aroma and flavor to Rotis. Its authentic whole-grain composition, with a high bran content, makes it a fiber-rich food. This contributes to the regulation of digestion, blood sugar, cholesterol, obesity, and enhances skin quality, offering various health benefits. The temperatures reached during the chakki (stone mill or grinder) process, generated through friction, typically range from 110-125°C. At these elevated temperatures, the carotenes in the bran release a distinctive roasty fragrance, lending the atta its golden color."
//           Link="/aata"
//         />
//       </div>

//       <div className="whiteComponentEcavo bg3">
//         <EcavoblackComponent
//           currrentImg={Img3}
//           heading="NANDI Besan"
//           text="Unleash the flavor revolution with Ecavo Spices - where each blend tells a tale of exotic lands and aromatic journeys. From the fiery embrace of cayenne to the soothing whispers of cinnamon, our spices dance on your palate, creating symphonies of taste. Elevate your culinary adventures with Ecavo, where every dish becomes a masterpiece in the making."
//           Link="/besan"
//         />
//       </div>

//       <div className="whiteComponentEcavo bg4">
//         <EcavowhiteComponent
//           currrentImg={Img4}
//           heading="NANDI Sooji"
//           text="Crafted from the finest quality whole wheat, our Sooji stands out as a premium offering to our customers. Rich in carbohydrates and protein, this Sooji is perfect for preparing delicious meals like Upma or Halwa. Elevate your culinary experience and treat yourself, as well as your loved ones, to delectable and appetizing food using our Premium Quality Sooji. Its crispy texture and subtle aroma contribute to delivering an enticing flavor to your dishes."
//           Link="/sooji"
//         />
//       </div>

//       <div className="whiteComponentEcavo bg5">
//         <EcavoblackComponent
//           currrentImg={Img5}
//           heading="NANDI Maida"
//           text="As a distinguished entity in the agro industry, we are committed to delivering a top-notch selection of Premium Maida. We meticulously process and pack the freshest and finest wheat with stringent standards to ensure prolonged freshness. Our essential maida is the key ingredient for preparing a variety of delectable dishes, spanning from breakfast delights to snack items. We extend an invitation for you to indulge in the unparalleled joy of premium maida, enabling you to create a feast for your friends and family using finely ground wheat grains from reliable sources."
//           Link="/maida"
//         />
//       </div>

//       <div className="whiteComponentEcavo bg6">
//         <EcavowhiteComponent
//           currrentImg={Img6}
//           heading="NANDI Himalayan Pink Rock Salt"
//           text="Experience the essence of culinary finesse with Himalayan salt. Elevate your cooking to new heights with the purity of Himalayan salt, harmonizing perfectly with the delicate texture of refined flour. Indulge in the art of gastronomy, where every dish becomes a masterpiece infused with the finest ingredients from nature's bounty."
//           Link="/salt"
//         />
//       </div>

//       <div className="whiteComponentEcavo bg7">
//         <EcavoblackComponent
//           currrentImg={Img7}
//           heading="NANDI Dalia"
//           text="Introducing Ecavo Daliya - the epitome of culinary excellence! Delight your senses with this premium blend, meticulously crafted to elevate your dishes to new heights. Experience the perfect fusion of tradition and innovation in every spoonful, as the rich aroma and superior texture of Ecavo flour daliya transform your cooking into a masterpiece. Elevate your culinary creations today with Ecavo - where quality meets perfection!"
//           Link="/dalia"
//         />
//       </div>

//       <div className="whiteComponentEcavo bg8">
//         <EcavowhiteComponent
//           currrentImg={Img11}
//           heading="NANDI Pickles"
//           text="Indulge in the tantalizing flavors of Ecavo's Nandi's Pickles, a fusion of delicate petals and tangy spices, handcrafted to perfection. Each jar is a symphony of notes and zesty undertones, promising a culinary adventure with every bite. Elevate your meals with the exquisite taste of Ecavo's pickles, adding a touch of elegance and sophistication to your dining experience."
//           Link="/pickles"
//         />
//       </div>

//       <div ref={recipesRef} className={`homeRecipies bg9 ${recipesInView ? 'animate' : ''}`}>
//         {[Img8, Img10, Img9].map((img, index) => (
//           <div key={index} className="recipe-item">
//             <Recipie
//               IMG={img}
//               RecipieName={
//                 index === 0
//                   ? "Maida Pizza Cone"
//                   : index === 1
//                   ? "Besan burfi"
//                   : "Whole Atta Cookies"
//               }
//               RecipieLink={
//                 index === 0
//                   ? "maidavegpizzacones"
//                   : index === 1
//                   ? "besanburfi"
//                   : "wholeattacookies"
//               }
//             />
//           </div>
//         ))}
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default Home;